module.exports = __webpack_public_path__ + "img/img-blue_bg.9aed1989.svg";